module.exports = __webpack_public_path__ + "img/acaki7.4139d587.jpg";